import { useTranslation } from 'react-i18next';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box, Grid, CircularProgress } from "@mui/material";
function LoadingComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return(
    <Box p={2}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <Typography variant="h5">{t("Seite wird geladen")}</Typography>
          <Box p={2}>
            <CircularProgress color="primary"/>
          </Box>
          <Button color="primary" onClick={() => navigate('/')}>{t("Zurück zum Verteiler")}</Button>
        </Grid>
      </Grid>
    </Box>
  );
}
export default LoadingComponent;
